import React from 'react'
import { currencyParser } from '../../../../utils'
import { ActiveDelayedInvoice } from './delayed-cards/active-delayed'
import { LockedDelayedInvoice } from './delayed-cards/locked-delayed'

export const CardDelayed = ({ item, getInvoice }) => {
  const invoiceIuguUrl = item?.url?.replace('faturas.iugu.com', 'checkout.iugu.com/invoices')

  return item?.shouldBlockDuplicateInvoice ? (
    <LockedDelayedInvoice
      item={item}
      formattedPrice={currencyParser(item.price || 0, 'R$')}
      dueDate={item.date}
      invoiceIuguUrl={invoiceIuguUrl}
    />
  ) : (
    <ActiveDelayedInvoice
      item={item}
      getInvoice={getInvoice}
      formattedPrice={currencyParser(item.price || 0, 'R$')}
      dueDate={item.date}
    />
  )
}
